import type { Finding, FindingStatus } from "./audit-data";
import { createSeverityBadge } from "./components/severity-badge";
import type { AssistantContext } from "./sections";

export interface FindingDetailDeps {
  readonly openAssistant: (context: AssistantContext) => void;
}

const STATUS_LABEL: Record<FindingStatus, string> = { pass: "合格", fail: "要対応", na: "対象外", review: "要確認" };

function section(title: string, text: string): HTMLElement {
  const s = document.createElement("section");
  const h = document.createElement("h3");
  h.className = "text-sm font-medium text-slate-700";
  h.textContent = title;
  const p = document.createElement("p");
  p.className = "mt-1 text-sm text-slate-700";
  p.textContent = text;
  s.append(h, p);
  return s;
}

export function createFindingDetail(finding: Finding, deps: FindingDetailDeps): HTMLElement {
  const c = finding.check;
  const wrap = document.createElement("div");
  wrap.className = "space-y-4";

  const head = document.createElement("div");
  head.className = "flex items-center gap-2";
  head.append(createSeverityBadge(c.severity));
  const status = document.createElement("span");
  status.className = "text-sm text-slate-600";
  status.textContent = STATUS_LABEL[finding.status];
  head.append(status);
  wrap.append(head);

  wrap.append(
    section("何を確認するか", c.what),
    section("なぜ重要か（リスク）", c.why),
    section("推奨対応", c.remediation),
    section("Salesforce 参照", c.salesforceReference),
  );

  if (finding.affectedResources.length > 0) {
    const s = document.createElement("section");
    const h = document.createElement("h3");
    h.className = "text-sm font-medium text-slate-700";
    h.textContent = "影響リソース（サンプル）";
    const ul = document.createElement("ul");
    ul.className = "mt-1 list-disc pl-5 text-sm text-slate-700";
    for (const r of finding.affectedResources) {
      const li = document.createElement("li");
      li.textContent = r;
      ul.append(li);
    }
    s.append(h, ul);
    wrap.append(s);
  }

  const ai = document.createElement("button");
  ai.type = "button";
  ai.className = "rounded bg-shinonome-700 px-3 py-2 text-sm font-medium text-white hover:bg-shinonome-800";
  ai.textContent = "AIに相談";
  ai.addEventListener("click", () =>
    deps.openAssistant({ title: c.title, prompt: "「" + c.title + "」の対応策を教えて" }),
  );
  wrap.append(ai);

  return wrap;
}
